<button
  mat-menu-item
  class="toggle-button"
  (click)="onClick()"
  [attr.title]="
    (isNodeLocked
      ? 'APP.ACTIONS.EDIT_OFFLINE_CANCEL'
      : 'APP.ACTIONS.EDIT_OFFLINE_DESCRIPTION'
    ) | translate
  "
>
  <ng-container *ngIf="isNodeLocked">
    <mat-icon>cancel</mat-icon>
    <span>{{
      'APP.ACTIONS.EDIT_OFFLINE_CANCEL' | translate
    }}</span>
  </ng-container>
  <ng-container *ngIf="!isNodeLocked">
    <mat-icon>edit</mat-icon>
    <span>{{ 'APP.ACTIONS.EDIT_OFFLINE' | translate }}</span>
  </ng-container>
</button>
